<template>
  <van-cell-group>
    <van-cell>
      <template #title>

        <van-row type="flex" justify="space-between">
          <van-col>
            科目
            <van-tag type="primary">{{ vip.description }}</van-tag>
            <!--                        科目 <van-tag type="primary">{{user.subject_name}}</van-tag>-->
          </van-col>
          <van-col>
            <van-button type="default" size="small" to="/subject">科目选择</van-button>
          </van-col>
        </van-row>
      </template>
      <template #label>
        <div style="font-size:0.9rem">{{ user.subject_name }}</div>
        <!--                <div>{{vip.description}}</div>-->
      </template>
    </van-cell>

  </van-cell-group>
</template>


<script>
export default {
  name: "current-subject",
  data() {
    return {
      vip: {},
      user: {}
    };
  },
  created() {
    this.getUserDetails()


  },
  methods: {
    getUserDetails() {
      this.$http.get("/wechat/user/details").then(res => {
        if (200 === res.data.code) {
          this.user = res.data.data.user;
          this.vip = res.data.data.vip;

          //设置web日志监控的用户id
          if (undefined !== res.data.data.user && null !== res.data.data.user) {
            localStorage.setItem("wmUserInfo", JSON.stringify({userId: res.data.data.user.id}));
          }
          if (this.user.subject_id <= 0) {
            this.$dialog.confirm({
              title: '选择科目提示',
              message: '请先选择一个科目',
              showCancelButton: false
            }).then(() => {
              this.$router.push('/subject');
            }).catch(() => {
              // on cancel
            });
            return;
          }
        }
      });
    }
  }
}
</script>
